import React from "react";
import { DataCard } from "./DataCard";
import { CustomCarousel } from "./CustomCarousel";

export const MobileLoanType = ({
  quotes,
  armFixedTermYears,
  loanTerm,
  isComparedIds,
  setComparedId,
  setDetails,
}) => {
  return (
    <>
      <div className="thirty-year-fixed-heading bold">
        {!armFixedTermYears
          ? `${loanTerm} Year Fixed`
          : `${armFixedTermYears}/6 Adjustable Rate`}
      </div>
      <CustomCarousel>
        {quotes.map((quote) => (
          <DataCard
            quote={quote}
            key={quote.id}
            isComparedIds={isComparedIds}
            setComparedId={setComparedId}
            setDetails={setDetails}
          />
        ))}
      </CustomCarousel>
    </>
  );
};
